/**
 * --------------------------------------------------------------------------
 * NJ : PasswordInput.js
 * --------------------------------------------------------------------------
 */

import { Data, EventHandler } from 'nj-utils';
import AbstractComponent from 'nj-components/AbstractComponent';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'password-input';
const DATA_KEY = `${coreConfig.KEY_PREFIX}.${NAME}`;
const SELECTOR = `.${coreConfig.KEY_PREFIX}-form-input-password`;
const INPUT_CLASS = `${coreConfig.KEY_PREFIX}-form-control`;
const REVEAL_BUTTON_CLASS = `${coreConfig.KEY_PREFIX}-form-control__password-off`;
const HIDE_BUTTON_CLASS = `${coreConfig.KEY_PREFIX}-form-control__password-on`;
const DEFAULT_CONFIG = {
  selector : SELECTOR
};

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class PasswordInput extends AbstractComponent {
  constructor(element, config) {
    super(PasswordInput, element);

    this.element = element;
    this.config = {
      ...DEFAULT_CONFIG,
      ...config
    };

    this.setListeners();
    Data.setData(element, DATA_KEY, this);
  }

  static init(options) {
    return super.init(this, options, SELECTOR);
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  setListeners() {
    const input = this.element.getElementsByClassName(INPUT_CLASS)[0];

    const revealButton = this.element.getElementsByClassName(REVEAL_BUTTON_CLASS)[0];
    EventHandler.on(revealButton,
      'click',
      () => {
        this.element.classList.add('is-visible');
        input.type = 'text';
      }
    );

    const hideButton = this.element.getElementsByClassName(HIDE_BUTTON_CLASS)[0];
    EventHandler.on(hideButton,
      'click',
      () => {
        this.element.classList.remove('is-visible');
        input.type = 'password';
      }
    );
  }

  // Static
  static selector = SELECTOR;
}

export default PasswordInput;
